import { jsx as _jsx } from "react/jsx-runtime";
import Lottie from 'lottie-react';
import styles from './StatusBanner.module.css';
import pendingAnim from './Banner_pending.json';
import classNames from 'classnames';
import { StatusBadgeState } from 'components/StatusBadge/SatusBadge.types';
export const StatusBanner = ({ state }) => {
    if (state === StatusBadgeState.pending) {
        return (_jsx("div", { className: styles.banner, children: _jsx(Lottie, { animationData: pendingAnim, loop: true }) }));
    }
    return _jsx("div", { className: classNames(styles.banner, styles.bannerCompleted) });
};
